export default function MySQL_CHECK() {
  return (
    <div>
      <h2>MySQL_CHECK</h2>    </div>
  );
}